export async function fetchLeaguePlayerData(league, year) {
  const apiLeague = league === "ncaa" ? "college_mens" : league === "ncaaw" ? "college_womens" : league;
  const rawPerGameResponse = await fetch(
    `${process.env.NEXT_PUBLIC_API_URL_API_URL}/api/${apiLeague}/${year}/players/per_game?per_page=150`
  );

  // If the response is not valid, return an empty array
  if (rawPerGameResponse.status !== 200) {
    return {
      rawPerGame: {
        data: [],
      },
    };
  }

  const rawPerGameData = await rawPerGameResponse.json();

  return {
    rawPerGame: rawPerGameData,
  };
}
